function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Col, Row, Table, Button } from 'reactstrap';
import { useField } from 'formik';
import { Input } from "./..";
import Icon from "../../common/icon";
import { Context } from "../../../services/context";
import { t } from "../../../services/translator";
import ModalContent from "./modal-content-add-lang";
import { Error } from "./..";

var TableLangValue = function TableLangValue(_ref) {
  var name = _ref.name,
      inputType = _ref.inputType;

  var _useContext = useContext(Context),
      openModal = _useContext.openModal,
      closeModal = _useContext.closeModal;

  var _useField = useField({
    name: name
  }),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      helpers = _useField2[2];

  var value = field.value;
  var setValue = helpers.setValue;

  var saveNewLang = function saveNewLang(lang) {
    if (!lang) {
      return;
    }

    if (!value || Array.isArray(value)) {
      value = {};
    }

    value[lang] = 'new';
    setValue(value);
  };

  var addLang = function addLang(e) {
    e.preventDefault();
    openModal(t('add_lang'), /*#__PURE__*/React.createElement(ModalContent, {
      onUpdate: function onUpdate(lang) {
        return saveNewLang(lang);
      },
      onClose: closeModal
    }));
  };

  var removeLang = function removeLang(e, lang) {
    e.preventDefault();

    if (value[lang]) {
      delete value[lang];
      setValue(value);
    }
  };

  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    color: "primary",
    size: "sm",
    onClick: function onClick(e) {
      return addLang(e);
    }
  }, t('add_lang')), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('lang')), /*#__PURE__*/React.createElement("th", null, t('value')), /*#__PURE__*/React.createElement("th", null, t('actions')))), /*#__PURE__*/React.createElement("tbody", null, value && Object.keys(value).map(function (lang) {
    return /*#__PURE__*/React.createElement("tr", {
      key: lang
    }, /*#__PURE__*/React.createElement("td", null, lang), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Input, {
      name: "".concat(name, "['").concat(lang, "']"),
      label: null,
      type: inputType
    })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      color: "danger",
      type: "button",
      onClick: function onClick(e) {
        return removeLang(e, lang);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "trash"
    }))));
  }))), /*#__PURE__*/React.createElement(Error, {
    name: name
  })));
};

TableLangValue.propTypes = {
  name: PropTypes.string.isRequired,
  inputType: PropTypes.string
};
TableLangValue.defaultProps = {
  inputType: 'text'
};
export default TableLangValue;